import { Form } from '../core'
import DatePickerFactory from 'jquery-datepicker'

$.fn.DateRangePicker = function() {
  let self = this

  self.dates = {
    start_date: undefined,
    end_date: undefined,
  }

  self.date_picker = undefined

  self.get_date_string = function(date) {
    if (date == undefined) {
      return ''
    }
    let month = date.getMonth() + 1,
    day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return date.getFullYear() + '-' + month + '-' + day
  }

  self.initialize_date_picker = function() {
    DatePickerFactory($)
    if (saintlo_l10n.LOCALE == 'fr') {
      $.datepicker.regional['fr'] = {
        closeText          : 'Fermer',
        prevText           : 'Précédent',
        nextText           : 'Suivant',
        currentText        : 'Aujourd\'hui',
        monthNames         : ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        monthNamesShort    : ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin',	'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
        dayNames           : ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
        dayNamesShort      : ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
        dayNamesMin        : ['Di','Lu','Ma','Me','Je','Ve','Sa'],
        weekHeader         : 'Sem.',
        dateFormat         : 'dd/mm/yy',
        firstDay           : 1,
        isRTL              : false,
        showMonthAfterYear : false,
        yearSuffix         : ''
      };
      $.datepicker.setDefaults($.datepicker.regional['fr']);
    }
    self.date_picker = self.find('.date-range-picker').datepicker({
      dateFormat: 'yy-mm-dd',
      numberOfMonths: ($.mlmi.mobile.isMobile || self.hasClass('reservation-widget')) ? 1 : 2,
      nextText: '',
      prevText: '',
      locale: 'fr',
      minDate: 0,
      maxDate: '+24M',
      onSelect: self.select_date,
      beforeShowDay: self.show_date,
    })
  }

  self.select_date = function(date) {
    date = new Date(date)
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    if (self.dates.start_date == undefined) {
      self.dates.start_date = date
      self.dates.end_date = undefined
    } else if (self.dates.end_date == undefined) {
      if (date > self.dates.start_date) {
        self.dates.end_date = date
      } else if (date < self.dates.start_date) {
        self.dates.start_date = date
        self.dates.end_date = undefined
      } else {
        // no change
      }
    } else {
      self.dates.start_date = date
      self.dates.end_date = undefined
    }
    self.find('input[name="date_start"]').val(self.get_date_string(self.dates.start_date)).trigger('change')
    self.find('input[name="date_end"]').val(self.get_date_string(self.dates.end_date)).trigger('change')
    self.trigger('dates_changed', [self.dates])
  }

  self.show_date = function(date) {
    let classes = '',
    date_string = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    if (self.dates.start_date != undefined && self.dates.end_date != undefined) {
      if (date >= self.dates.start_date && date <= self.dates.end_date) {
        classes += 'date-in-range ';
      }
    }
    if (self.dates.start_date != undefined) {
      let start_date_string = self.dates.start_date.getFullYear() + '-' + (self.dates.start_date.getMonth() + 1) + '-' + self.dates.start_date.getDate()
      if (date_string == start_date_string) {
        return [true, classes + 'start-date']
      }
    }
    if (self.dates.end_date != undefined) {
      let end_date_string = self.dates.end_date.getFullYear() + '-' + (self.dates.end_date.getMonth() + 1) + '-' + self.dates.end_date.getDate()
      if (date_string == end_date_string) {
        return [true, classes + 'end-date']
      }
    }
    if (classes != '') {
      return [true, classes]
    }
    return [true, false]
  }

  return function() {
    self.initialize_date_picker()
    $.mlmi.mobile.add(function() {
      if (self.date_picker != undefined) {
        self.date_picker.datepicker('destroy')
        self.initialize_date_picker()
      }
    }, function() {
      if (self.date_picker != undefined) {
        self.date_picker.datepicker('destroy')
        self.initialize_date_picker()
      }
    })
    return self
  }()
}

$.fn.ReservationForm = function() {
  let self = $(this).BlockElement()

  if (self.data('reservation-form')) {
    return self.data('reservation-form')
  }

  self.form = undefined
  self.steps = undefined
  self.picker = undefined
  self.location = undefined

  self.initialize_fields = function() {
    /* Location select */
    self.location = self.find('input[name="location_choice"]')
    self.location.on('change', function() {
      self.find('.form-step:last-child .steps-nav-container').find('.card-locator-item').remove()
      let card_item = $(this).closest('.field--type-radio').find('.card-locator-item').clone()
      self.setup_step_2(card_item)
      self.find('.form-step:last-child .steps-nav-container').prepend(card_item)
      $(this).closest('.form-step').find('.field__next').click()
    })

    /* Remove extra tabindex attribute */
    self.find('.field-container > .field--type-radio, input[name="location_choice"]').attr('tabindex', '-1')
    self.find('.field').each(function() {
      $(this).keypress(function(e) {
        if (e.keyCode == 32 || e.keyCode == 13) {
          $(this).find('input[name="location_choice"]').prop('checked', true).change()
        }
      })
    })

    /* Disabled */
    $('input[name="date_start"]').prop('disabled', true)
    $('input[name="date_end"]').prop('disabled', true)

    /* Date range picker */
    self.picker = self.steps.get_step(2).DateRangePicker()
  }

  self.setup_step_2 = function(card_item) {
    if (self.form != undefined) {
      let location_choice = self.form.getForm().get_form_value('location_choice')
      if (location_choice == 'montreal' || location_choice == 'ottawa-jail') {
        $('.reservation-notice').addClass('d-flex')
        $('.redirect-notice').removeClass('d-inline-block')
      } else {
        $('.reservation-notice').removeClass('d-flex')
        $('.redirect-notice').addClass('d-inline-block')
      }

      if (card_item.data('direct-link') == 1) {
        self.find('.date-picker-indicator').addClass('--simple')
        self.find('.submit-container').addClass('--simple')
        self.find('.col-md-8.offset-md-1').hide()
        self.find('.form-tabs__item[data-index="2"]').text(saintlo_l10n.TAB_ALT_2)
      } else {
        self.find('.date-picker-indicator').removeClass('--simple')
        self.find('.submit-container').removeClass('--simple')
        self.find('.form-tabs__item[data-index="2"]').text(saintlo_l10n.TAB_ALT_1)
        self.find('.col-md-8.offset-md-1').show()
      }
    }
  }

  self.initialize_form = function() {
    /* set initial step */
    let hash_parts = window.location.hash.split('/')
    if (hash_parts[0] == '#' + saintlo_l10n.STEP + '-2') {
      let checked_option = self.find('input[name="location_choice"][value="' + hash_parts[1] + '"]')
      if (checked_option.length) {
        checked_option.prop('checked', true)
        let card_item = checked_option.closest('.field--type-radio').find('.card-locator-item').clone()
        self.find('.form-step:last-child .steps-nav-container').prepend(card_item)
        $('.form-steps').attr('data-step', 2)
      }
    }

    /* Initialize form */
    self.form = new Form(self.get(0), {
      auto_scroll: false,
      steps: {
        use_steps: true,
        initial_step: 2,
        submit_steps: false,
      },
      onSubmit: function() {
        self.form.getForm().enable_fields()
      },
      onSuccess: function() {
        //
      },
      onError: function() {
        //
      },
      onStep: function(form) {
        let targetTop = self.offset().top - $('.header').outerHeight(false) - ($.mlmi.mobile.isMobile ? 32 : 50)
        if (targetTop < $(window).scrollTop()) {
          $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
        }
        if (form.current_index == 1) {
          self.find('input[name="location_choice"]:checked').prop('checked', false)
          window.location.hash = saintlo_l10n.STEP + '-' + form.current_index
        } else if (form.current_index == 2) {
          window.location.hash = saintlo_l10n.STEP + '-' + form.current_index + '/' + self.find('input[name="location_choice"]:checked').val()
        }
      },
    })

    /* set initial step */
    if (hash_parts[0] == '#' + saintlo_l10n.STEP + '-2') {
      let checked_option = self.find('input[name="location_choice"][value="' + hash_parts[1] + '"]')
      if (checked_option.length) {
        let card_item = checked_option.closest('.field--type-radio').find('.card-locator-item').clone()
        self.setup_step_2(card_item)
        $('.form-steps').attr('data-step', 2)
      }
    }

    /* setup steps */
    self.steps = self.form.getForm().steps
  }

  self.initialize_navigation = function() {
    $(window).on('popstate', function() {
      let hash_parts = window.location.hash.split('/')
      if (hash_parts[0] == '#' + saintlo_l10n.STEP + '-1' && self.steps.current_index == 2) {
        self.steps.go_to_step(1)
        self.find('input[name="location_choice"]:checked').prop('checked', false)
      } else if (hash_parts[0] == '#' + saintlo_l10n.STEP + '-2' && self.steps.current_index == 1) {
        self.find('input[name="location_choice"][value="' + hash_parts[1] + '"]').prop('checked', true)
        self.steps.go_to_step(2)
      }
    })
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    self.initialize_navigation()
    self.data('reservation-form', self)
    return self
  }()
}
